<template>
  <span>
    {{ description }}
  </span>
</template>

<script>
export default {
  props: {
    value: Boolean,
    yesDescription: {
      type: String,
      default: 'Sim',
    },
    noDescription: {
      type: String,
      default: 'Não',
    },
  },
  computed: {
    description() {
      if (this.value) {
        return this.yesDescription;
      }
      return this.noDescription;
    },
  },
};
</script>
